import _ from 'lodash';
import {SDVolumePropertyKeyEnum} from '../../../../constants/dataEnum';
import {getGCDFromArray} from '../../../../lib/numericHelper';

const getBowStyledArrowNumBox = (arrowDefinition) => {
  const numBoxProps = [];

  arrowDefinition.forEach((val) => {
    const xOffset = val.textBoxLabel ? 0.08 : 0.035;
    const pos = {
      x: (val.toX + val.fromX) / 2 - window.innerWidth * xOffset,
      y: val.fromY - val.offset / 2 - 10,
    };
    numBoxProps.push({position: pos, label: val.textBoxLabel});
  });

  return numBoxProps;
};

const getAllDiluentVolumeNumBox = (arrowPos) => {
  const xDiluent = `${((arrowPos[0].fromX + arrowPos[0].toX) / 2 / window.innerWidth) * 100 - 5}vw`;
  const yDiluent = `${((arrowPos[0].toY + arrowPos[0].distanceToEdge) / window.innerHeight) * 100 - 5.5}vh`;
  return [{position: {x: xDiluent, y: yDiluent}, label: arrowPos[0].textBoxLabel}];
};

const getEachStepDiluentVolumeNumBox = (arrowPos) => {
  const numBoxProps = [];

  arrowPos.forEach((val) => {
    const x = `${(val.toX / window.innerWidth) * 100 - 3.8}vw`;
    const y = (val.toY + (val.toY + val.distanceToEdge)) / 2 - window.innerHeight * 0.02;

    numBoxProps.push({position: {x, y}});
  });

  return numBoxProps;
};

export const getFloatingVolumeBox = (arrowPos) => {
  // index 0 and 1 are diluent arrows on the bottom that have a custom numbox position
  const volumeBoxProps = {
    [arrowPos[0].key]: getAllDiluentVolumeNumBox(arrowPos[0].props),
    [arrowPos[1].key]: getEachStepDiluentVolumeNumBox([...arrowPos[0].props, ...arrowPos[1].props]),
  };

  // the rest placed the numbox in the center position of bow styled arrow
  for (let i = 2; i < arrowPos.length; i += 1) {
    volumeBoxProps[arrowPos[i].key] = getBowStyledArrowNumBox(arrowPos[i].props);
  }

  return volumeBoxProps;
};

export const isStepVolumeValueUniform = (key, sdProperty, includesFirstIndex = true) => {
  const {step} = sdProperty;
  const stepProperties = sdProperty?.stepProperties ?? [];
  const stepVolumeList = [
    ...new Set(stepProperties.slice(includesFirstIndex ? 0 : 1, step).flatMap((prop) => (prop[key] ? prop[key] : []))),
  ];

  return {isVolumeUniform: stepVolumeList.length === 1, stepVolumeList};
};

export const processStepVolumeChange = (newValObj, stepProperty, isChangeRatio, isChangeAffectedVolume) => {
  const key = Object.keys(newValObj)[0];
  const newVal = Number(Number(newValObj[key]).toFixed(1));

  if (key === SDVolumePropertyKeyEnum.RATIO) return {};

  const newStepProperty = {...stepProperty, [key]: newVal || 0};

  const {stepSampleVolume, stepDiluentVolume, ratio} = newStepProperty;

  const [ratioSample, ratioTotal] = ratio || [];

  const affectedKey =
    key === SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME
      ? SDVolumePropertyKeyEnum.STEP_DILUENT_VOLUME
      : SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME;

  const isDefaultRatio =
    !(ratioSample && ratioTotal) || (ratioSample === 0 && ratioTotal === 0) || (ratioSample === 1 && ratioTotal === 1);

  if ((!isDefaultRatio && !isChangeRatio) || isChangeAffectedVolume) {
    newStepProperty[affectedKey] = Number(
      Number(
        key === SDVolumePropertyKeyEnum.STEP_SAMPLE_VOLUME
          ? (newVal * (ratioTotal - ratioSample)) / ratioSample
          : (ratioSample * newVal) / (ratioTotal - ratioSample),
      ).toFixed(1),
    );

    newStepProperty[affectedKey] = _.isFinite(newStepProperty[affectedKey]) ? newStepProperty[affectedKey] : 0;
  } else if (stepProperty && stepProperty[affectedKey]) {
    const isInteger = Number.isSafeInteger(stepSampleVolume) && Number.isSafeInteger(stepDiluentVolume);
    const roundingNumber = isInteger ? 1 : 10;
    newStepProperty.ratio = [
      stepSampleVolume * roundingNumber,
      stepDiluentVolume * roundingNumber + stepSampleVolume * roundingNumber,
    ];
  } else {
    newStepProperty.ratio = [1, 1];
    newStepProperty[affectedKey] = 0;
  }

  const GCD = getGCDFromArray(newStepProperty.ratio);
  const ratioSampleNew = Number(Number(newStepProperty.ratio[0]) / GCD);
  const ratioTotalNew = Number(Number(newStepProperty.ratio[1]) / GCD);

  newStepProperty.ratio = [ratioSampleNew, ratioTotalNew];

  return newStepProperty;
};

export const validateVolumeInput = (volume, recommendedVolume) => volume < recommendedVolume && volume !== 0;
